/* ============
 * Field Transformer
 * ============
 */

import Transformer from './transformer';
import fieldType from './fieldType';

export default class FieldTransformer extends Transformer {

  static fetch(model) {
    return {
      id: model.id,
      name: model.name,
      fieldType: model.field_type !== undefined ? fieldType.fetch(model.field_type) : [],
      isRequired: model.is_required,
      defaultValue: model.default_value,
      createdAt: model.created_at,
      options: model.options,
    };
  }

  static send(model) {
    return {
      id: model.id,
      name: model.name,
    };
  }
}



// WEBPACK FOOTER //
// ./src/app/transformers/field.js